import Game from "./components/Game";

export function App() {
  return (
    <main className="min-h-screen min-w-screen bg-gradient-to-br from-[#9796F0] to-[#FBC7D4]">
      <Game />
    </main>
  );
}
